import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowLeftLineIcon from "@rsuite/icons/ArrowLeftLine";
import { DashboardMenu } from "../data/menu";
import DashboardInfo from "./Dashboard/DashboardInfo";

export default function Dashboard() {
  const { t } = useTranslation();
  const sections = DashboardMenu.filter((item) => item.show);

  return (
    <div className="directions space-y-6 pb-8">
      <header className="rounded-xl border border-slate-200/80 bg-white px-4 py-4 shadow-sm sm:px-5 sm:py-5">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="text-xs font-medium text-slate-500">NanoSeal Admin</p>
            <h1 className="mt-1 text-xl font-bold text-slate-900 sm:text-2xl">
              {t("Dashboard")}
            </h1>
            <p className="mt-1 text-sm text-slate-500">
              خلاصه فروش و دسترسی سریع به بخش‌های مدیریت
            </p>
          </div>
          <div className="rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-500">
            {new Date().toLocaleDateString("fa-IR", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </div>
        </div>
      </header>

      <section aria-labelledby="dashboard-stats-heading">
        <div className="mb-3 flex items-center justify-between gap-2">
          <h2 id="dashboard-stats-heading" className="text-sm font-semibold text-slate-800">
            آمار فروش
          </h2>
        </div>
        <DashboardInfo />
      </section>

      <section aria-labelledby="dashboard-shortcuts-heading">
        <div className="mb-3 flex items-center justify-between gap-2">
          <h2 id="dashboard-shortcuts-heading" className="text-sm font-semibold text-slate-800">
            میانبرهای مدیریت
          </h2>
          <span className="text-xs text-slate-400">{sections.length} بخش</span>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
          {sections.map((item) => {
            const Icon = item.Icon;
            return (
              <article
                key={item.name}
                className="group flex flex-col overflow-hidden rounded-xl border border-slate-200/80 bg-white shadow-sm transition duration-200 hover:border-slate-300 hover:shadow-md"
              >
                <Link
                  to={item.url}
                  className="flex items-start gap-3 border-b border-slate-100 p-4 transition-colors hover:bg-slate-50/80"
                >
                  <div
                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-white"
                    style={{ backgroundColor: item.color || "#334155" }}
                  >
                    <Icon className="text-[18px] text-white" />
                  </div>
                  <div className="min-w-0 flex-1 text-start">
                    <h3 className="font-semibold text-slate-800 group-hover:text-slate-950">
                      {t(item.name)}
                    </h3>
                    <p className="mt-0.5 text-xs text-slate-500">
                      {item.sub.length} زیرفرعی
                    </p>
                  </div>
                  <ArrowLeftLineIcon className="mt-1 shrink-0 text-slate-300 transition group-hover:text-slate-500" />
                </Link>

                {item.sub.length > 0 && (
                  <ul className="flex flex-wrap gap-1.5 p-3">
                    {item.sub.map((sub) => {
                      const SubIcon = sub.Icon;
                      return (
                        <li key={sub.url}>
                          <Link
                            to={sub.url}
                            className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-slate-50 px-2.5 py-1.5 text-xs font-medium text-slate-600 transition hover:border-slate-300 hover:bg-white hover:text-slate-900"
                          >
                            <SubIcon className="text-[12px] text-slate-500" />
                            {t(sub.name)}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </article>
            );
          })}
        </div>
      </section>
    </div>
  );
}
